import Moment from 'moment';
import { Component, Prop , Mixins } from 'vue-property-decorator';
import { CourseToolsMixin } from './course-tools.mixin';
import { IParamsCreateObject } from '../interfaces/params-create-object.interface';
import { COURSES_EVENTS } from '@/courses/values/courses-events.values';
import KEYS from '@/values/keys';
import Course from '@/content/models/course.model';
import { Section, SectionSubmissionDates } from '@/courses/models/section.model';
import { STORE } from '@/core/store/core.store';
import { EdContextMenuModel } from '@/plugins/ed-context-menu/ed-context-menu.plugin';
import { Holiday } from '@/tools/models/holiday.model';
import { SCHOOL_DAY_STATUS } from '@/tools/values/school-calendar.values';
import i18n from '../../lang/i18n';
import { SectionSchooolCalendarProvider } from '@/sections/providers/section-school-calendar.provider';
import EdSelectComponentCourse from '@/course-templates/components/ed-select-component-course/ed-select-component-course.component.vue';
import {IParamsCreateComponent} from '@/courses/interfaces/params-create-component.interface';

@Component({
  components:{
    EdSelectComponentCourse}})
export class CreateObjectsMixin extends Mixins(CourseToolsMixin) {

  /* Props */
  @Prop() readonly params: any;

  /* Data */
  public form: any = null;
  public showEduacComponentModal: boolean = false;
  public paramsComponent: any = {};

  /* Computed */
  get holidaysList() {
    return SectionSchooolCalendarProvider.holidays;
  }

  get schooldaysList() {
    // return this.$store.state.ScoolCalendarStore.schooldaysList;
    return SectionSchooolCalendarProvider.schoolDaysList;
  }

  get hasGradeField() {
    return this.params.hasGradeField;
  }

  get course(): Course {
    return this.params ? this.getCourseFromStore({courseId: this.params.courseId}) : new Course();
  }
  
  get isFeedBack(): boolean {
    return this.params.modalBusSaveEvent.startsWith('RESPONSE_HOMEWORK');
  }

  get hasSchoolDays(): boolean {
    return this.schooldaysList.length > 0;
  }

  get hasGrading() {
    return this.course.hasGrading;
  }

  get holidays(): string[] {
    let dates: string[] = [];
    let holidays: Holiday[] = this.holidaysList;
    holidays.forEach(h => {
      dates.push(h.startDate);
      if(h.endDate) {
        dates.push(h.endDate);
      }
    });
    return dates;
  }

  get schoolDaysList() {
    return this.hasSchoolDays ? this.schooldaysList : [];
  }

  get currentSchoolDays(): string[] {
    let schoolDays: any[] = this.hasSchoolDays ? this.schooldaysList : [];
    let now = Moment(Moment().format('YYYY-MM-DD'));
    let dates = schoolDays.filter(sd => {
      let isValid = now.isSame(Moment(sd)) || now.isBefore(Moment(sd));
      if(this.params) {
        if(this.params.minDate) {
          let min = Moment(this.params.minDate);
          let isMinDateValid = min.isSame(Moment(sd)) || min.isBefore(Moment(sd));
          isValid = isValid && isMinDateValid;
        }
      }
      return isValid;
    });
    return dates;
  }

  /* Due date & Last Date to Submit */
  get defaultDueDate() {
    let defaultLastDate = '';
    if(this.course && this.hasSchoolDays) {
      const schooldays = this.currentSchoolDays;
      let day = this.course.defaultDueDateForTasks;
      if(this.currentSchoolDays.length > 0) {
        defaultLastDate = schooldays[schooldays.length - 1];
        if(this.currentSchoolDays.length > day) {
          defaultLastDate = schooldays[day];
        }
      }
    }
    return defaultLastDate;
  }

  get defaultLastDate() {
    return this.getDefaultLastDate();
  }

  get allowedDatesToLastDate() {
    let allowedDates = [...this.currentSchoolDays];
    if(this.form && this.form.dueDate) {
      const i = allowedDates.findIndex(d => d == this.form.dueDate.value);
      allowedDates.splice(0, i);
    }
    return allowedDates;
  }

  get canValidateDueDate() {
    return this.form && this.form.dueDate && this.defaultDueDate ? true : false;
  }

  get canValidateLastDate() {
    return this.form && this.form.dueDate && this.defaultLastDate ? true : false;
  }

  get dueDateDisclamer() {
    return this.getDateDisclamer(
      this.defaultDueDate,
      this.canValidateDueDate,
      'dueDate',
      'dueDateAuto'
    );
  }

  get lastDateDisclamer() {
    return this.getDateDisclamer(
      this.defaultLastDate,
      this.canValidateLastDate,
      'lastDate',
      'lastDateAuto'
    );
  }

  get dueDateInfo() {
    let res = { dueDateAuto: true, lastDateAuto: true };
    if(this.form) {
      const formHasDates = this.form.dueDate || this.form.lastDate;
      if(this.defaultDueDate && this.defaultLastDate && formHasDates) {
        const resByDefault = () => {
          res.dueDateAuto = this.form.dueDate.value === this.defaultDueDate;
          res.lastDateAuto = this.form.lastDate.value === this.defaultLastDate;
        }
        if(!this.params.edition) {
          resByDefault();
        } else {
          let dates: SectionSubmissionDates = this.params.section ? this.params.section.submissionDates : this.params.submissionDates;
          if(dates) {
            let isTheSameDueDate = dates.dueDate === this.form.dueDate.value;
            let isTheSameLastDate = dates.lastDate === this.form.dueDate.value;
            res.dueDateAuto = isTheSameDueDate && dates.dueDateAuto ? true : this.form.dueDate.value === this.defaultDueDate;
            res.lastDateAuto = dates.lastDateAuto && isTheSameLastDate ? true : this.form.lastDate.value === this.defaultLastDate;
          } else {
            resByDefault();
          }
        }
      }
    }
    return res;
  }

  get submissionDates() {
    if(this.params.section) {
      return this.params.section.submissionDates;
    } else if(this.params.submissionDates) {
      return this.params.submissionDates;
    }
  }

  get components() {
      return this.course.eduacComponents;
    }

  get componentSelected() : IParamsCreateComponent {
    return this.$store.state.CourseStore.eduacComponentSelected;
  }

  set componentSelected(newValue : IParamsCreateComponent) {
    this.$Courses.Store.setEduacComponentSelected(newValue);
  }

  /* Methods */
  createObject(req: IParamsCreateObject): Promise<void> {
    return new Promise((resolve, reject) => {
      this.$Courses.Store.createSectionFromObjectA(req)
      .then(async (res) => {
        await this.goToRefreshSectionsTree({
          sectionId: res.id,
          parentId: req.parentId, 
          courseId: req.courseId,
          classId: req.classId
        });
        this.setParentSectionState({
          sectionId: req.parentId,
          courseId: req.courseId, 
          classId: req.classId,
          opened: true
        });
        resolve();
      })
      .catch((error) => {
        if(error.data?.status !== 400 && !error.data?.errors) {
          this.triggerErrorModal(error.data || error);
        }
        reject(error);
      });
    });
  }

  editObject(req: Section): Promise<void> {
    return new Promise((resolve, reject) => {
      this.$Courses.Store.updateSectionA(req)
      .then(() => {
        this.goToSectionPreview({sectionId: req.sectionId , courseId: req.courseId,
        classId: req.classId});
        resolve();
      })
      .catch((error) => {
        this.triggerErrorModal(error.data || error);
        reject();
      });
    });
  }

  changeComponent(data) {
    this.componentSelected = data;
  }

  setParentSectionState(sectionInfo: { 
    sectionId: number,
    courseId: number,
    classId: number,
    opened?: boolean 
  }) {
    this.$edEventBus.$emit(COURSES_EVENTS.SECTION_OPENED, sectionInfo);
    this.$edEventBus.$emit(COURSES_EVENTS.SECTION_SELECTED, sectionInfo);
  }

  triggerErrorModal(err) {
    if(err && err.error === 'BAD_REQUEST') {
      const hasErrorCode = err.errors && err.errors.length > 0;
      const errorCode = err.errors[0].status;
      if(hasErrorCode) {
        if(i18n.en.errors.codes[errorCode]) {
          this.showModalErrorByCode(errorCode);
          return;
        }
      }
    }
    this.showModalError();
  }

  showModalError() {
    this.$EdModal.createMessageModal({
      title: this.$i18n.t('courses.errors.errorTitle'),
      body: this.$i18n.t('courses.errors.errorSavingObject'),
      type: KEYS.EVENT_TYPES.DANGER
    });
  }

  showModalErrorByCode(code: string) {
    this.$EdModal.createMessageModal({
      title: this.$i18n.t('courses.errors.errorTitle'),
      body: this.$i18n.t(`errors.codes.${code}`),
      type: KEYS.EVENT_TYPES.DANGER
    });
  }

  async refreshSelectedStudentWidget() {
    let student = { ...this.$store.state.HomeworksStore.teacherWidgetHomeworks.personSelected };
    student.homeworks.page = 0;
    await this.$store.dispatch(STORE.HOMEWORKS.ACTIONS.SELECT_WIDGET_TEACHER_PERSON_SELECTED_ALL,{student,isReload:true});
  }

  /* School Days */
  hideSchoolDay() {
    this.$EdContextMenu.close();
  }

  showSchoolDay({date, position}: { date: string, position: { x: number, y: number } }) {
    let dates = this.schooldaysList;
    let day = dates.findIndex(d => d == date);
    let text = `${this.$i18n.t('tools.schooldays.schoolDay')}: ${day + 1}`;
    this.$EdContextMenu.show(new EdContextMenuModel({
      position: { x: position.x, y: position.y },
      options: [{ id: date, text }],
    }));
  }

  getSchoolDayIndex(date: string = ''): number {
    let day = null;
    if(date) {
      day = this.schooldaysList.findIndex(d => d == date);
      day++;
    }
    return day
  }

  getSchoolDayDate(dateIndex: number = null) {
    let date = '';
    if(dateIndex) {
      return date = this.schooldaysList[dateIndex - 1];
    }
    return date;
  }

  getEventsColor(date: string) {
    let holidays: Holiday[] = this.holidaysList;
    let colors = this.$store.state.SchoolCalendarStore.preferences.colors;
    let holiday = holidays.find(h => h.startDate == date || h.endDate == date);
    if(holiday) {
      if(holiday.official) {
        return colors.US_HOLIDAYS;
      }
      if(holiday.status == SCHOOL_DAY_STATUS.NOTIFIED) {
        return colors.EVENTS;
      }
      if(!holiday.official && holiday.status == SCHOOL_DAY_STATUS.OBSERVED) {
        return colors.DAY_OFF;
      }
    }
  }

  getDateDisclamer(
    defaultDate: string,
    canValidate: boolean,
    field: string,
    autoProp: string) {
    let res = '';
    const dates = this.submissionDates;
    if(canValidate) {
      if(this.params.edition) {
        if(dates) {
          if(dates[autoProp] && dates[field] === this.form[field].value) {
            res = '';
          } else {
            res = this.getDueDateMessage(this.form[field].value, defaultDate);
          }
          return res;
        }
      }
      return this.getDueDateMessage(this.form[field].value, defaultDate);
    }
  }

  getDueDateMessage(dueDate: string, dateToCompare: string): string {
    if(dueDate) {
      if(dateToCompare !== dueDate) {
        return this.$i18n.t('courses.objects.dateChangedManually').toString();
      }
    }
    return '';
  }

  isHomeworkChanged(value) {
   if(this.hasSchoolDays) {
      if(value) {
        this.form.set('dueDate', this.defaultDueDate);
        this.form.set('lastDate', this.defaultLastDate);
      } else {
        this.form.set('dueDate', '');
        this.form.set('lastDate', '');
      }
    }
  }

  onDueDateChange(dueDate) {
    if(!dueDate) {
      this.form.set('lastDate', '');
    } else {
      setTimeout(() => {
        const defaultLastDate = this.getDefaultLastDate(dueDate);
        if(defaultLastDate) {
          this.form.set('lastDate', defaultLastDate);
        }        
      }, 5);
    }
  }

  getDefaultLastDate(dueDate = '') {
    let defaultLastDate = '';
    if(this.course && this.hasSchoolDays) {
      const schoolDays = this.currentSchoolDays;
      let lastDateIndex = this.course.defaultLastDateForTasks + this.course.defaultDueDateForTasks;
      let defaultDueDay = schoolDays.length - 1;
      if(dueDate) {
        if(dueDate !== this.defaultDueDate) {
          defaultDueDay = schoolDays.findIndex(day => day === this.form.dueDate.value);
          lastDateIndex = defaultDueDay + this.course.defaultLastDateForTasks;
        }
      }
      if(schoolDays.length > 0) {
        defaultLastDate = schoolDays[defaultDueDay];
        if(schoolDays.length > lastDateIndex) {
          defaultLastDate = schoolDays[lastDateIndex];
        }
      }
    }
    return defaultLastDate;
  }

  refreshContent({ sectionId, parentId , courseId, classId }: { 
    sectionId: number, 
    parentId: number,
    courseId: number,
    classId: number
  }): Promise<void> {
    return new Promise((resolve, reject) => {
      this.goToRefreshSectionsTree({sectionId, parentId, courseId, classId}).then(() => {
        resolve();
      }).catch((err) => {
        reject(err); 
      });
    });
  }
  
}
